import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const LogoImageBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
`;
